interface IGetKanbanColumnItemCountParams {
    firstRenderFinished: boolean;
    hasOrderData: boolean;
    totalFiltered: number;
}

export const getKanbanColumnItemCount = (
    params: IGetKanbanColumnItemCountParams
) => {
    const { firstRenderFinished, hasOrderData, totalFiltered } = params;
    if (!firstRenderFinished && !hasOrderData) {
        return 0;
    }
    return totalFiltered;
};
